import { Button, Checkbox, FormControlLabel, Stack } from '@mui/material';
import axios from '../../util/Axios';
import { useState } from 'react';
import { CORTICAL_TYPES, HEMORRHAGIC_SIDE_VALUES, HEMORRHAGIC_SUBCORTICAL_TYPES, SIDE_VALUES, SUBCORTICAL_TYPES } from './NeurologicalExamination/Config';
import { CustomSelect } from './NeurologicalExamination/CustomSelect';
import { SectionHeader } from './SectionHeader';

const wide = '360px';

export function EditImagingResults({ neurologicalExamination, onCancel, testId, onSaved }) {
  const [ischemic, setIschemic] = useState(!!neurologicalExamination?.ischemic);
  const [side, setSide] = useState(neurologicalExamination?.ischemic?.side || '');
  const [cortical, setCortical] = useState(neurologicalExamination?.ischemic?.cortical || []);
  const [subcortical, setSubcortical] = useState(neurologicalExamination?.ischemic?.subcortical || []);

  const [hemorrhagic, setHemorrhagic] = useState(!!neurologicalExamination?.hemorrhagic);
  const [hemorrhagicSide, setHemorrhagicSide] = useState(neurologicalExamination?.hemorrhagic?.side || '');
  const [hemorrhagicCortical, setHemorrhagicCortical] = useState(neurologicalExamination?.hemorrhagic?.cortical || []);
  const [hemorrhagicSubcortical, setHemorrhagicSubcortical] = useState(neurologicalExamination?.hemorrhagic?.subcortical || []);

  const [lvo, setLvo] = useState(neurologicalExamination?.lvo || false);
  const [thrombolyticGiven, setThrombolyticGiven] = useState(neurologicalExamination.thrombolyticGiven);
  const [thrombectomyPerformed, setThrombectomyPerformed] = useState(neurologicalExamination.thrombectomyPerformed);


  const handleSave = () => {
    const neurogicalExaminationToSave = {
      ...neurologicalExamination,
      ischemic: ischemic ? { side, cortical, subcortical } : null,
      thrombolyticGiven,
      hemorrhagic: hemorrhagic ? { side: hemorrhagicSide, cortical: hemorrhagicCortical, subcortical: hemorrhagicSubcortical } : null,
      lvo,
      thrombectomyPerformed
    };

    axios(`/strokeTests/${testId}/neurologicalExamination/v2`, {
      method: 'PUT',
      data: neurogicalExaminationToSave,
    }).then(() => onSaved(neurogicalExaminationToSave), onCancel);
  };

  return (
    <Stack>
      <SectionHeader name="Imaging Results" />
      <FormControlLabel control={<Checkbox checked={ischemic} onChange={(e) => setIschemic(e.target.checked)} />} label="Ischemic" />
      {ischemic ? (
        <Stack sx={{ marginLeft: '20px' }}>
          <CustomSelect value={side} valueChanged={setSide} label="Side" values={SIDE_VALUES} width={wide} />
          <CustomSelect multiple={true} value={cortical} valueChanged={setCortical} label="Cortical" values={CORTICAL_TYPES} width={wide} />
          <CustomSelect multiple={true} value={subcortical} valueChanged={setSubcortical} label="Subcortical" values={SUBCORTICAL_TYPES} width={wide} />
        </Stack>
      ) : (
        ''
      )}

      <FormControlLabel control={<Checkbox checked={thrombolyticGiven} onChange={(e) => setThrombolyticGiven(e.target.checked)} />} label="Thrombolytic Given" />

      <FormControlLabel control={<Checkbox checked={hemorrhagic} onChange={(e) => setHemorrhagic(e.target.checked)} />} label="Hemorrhagic" />
      {hemorrhagic ? (
        <Stack sx={{ marginLeft: '20px' }}>
          <CustomSelect value={hemorrhagicSide} valueChanged={setHemorrhagicSide} label="Side" values={HEMORRHAGIC_SIDE_VALUES} width={wide} />
          <CustomSelect multiple={true} value={hemorrhagicCortical} valueChanged={setHemorrhagicCortical} label="Cortical" values={CORTICAL_TYPES} width={wide} />
          <CustomSelect multiple={true} value={hemorrhagicSubcortical} valueChanged={setHemorrhagicSubcortical} label="Subcortical" values={HEMORRHAGIC_SUBCORTICAL_TYPES} width={wide} />
        </Stack>
      ) : (
        ''
      )}

      <FormControlLabel control={<Checkbox checked={lvo} onChange={(e) => setLvo(e.target.checked)} />} label="LVO" />

      <FormControlLabel control={<Checkbox checked={thrombectomyPerformed} onChange={(e) => setThrombectomyPerformed(e.target.checked)} />} label="ThrombectomyPerformed" />

      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          {' '}
          Save{' '}
        </Button>
      </Stack>
    </Stack>
  );
}
